import { render } from "./animationStar.vue?vue&type=template&id=dcc03ce2&scoped=true"
import script from "./animationStar.vue?vue&type=script&lang=js"
export * from "./animationStar.vue?vue&type=script&lang=js"

import "./animationStar.vue?vue&type=style&index=0&id=dcc03ce2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc03ce2"]])

export default __exports__